<template>
  <div>
    <el-card :body-style="{ padding: '0px'}" style="width: calc(100% - 40px);height: 300px;margin: 0 20px">

      <el-image style="width: 100%; height: 300px" :src="title_image" fit="cover">
      </el-image>
    </el-card>

    <el-container>
      <el-aside width="calc(100% - 385px)">

        <el-container>

          <!--封面图片-->
          <el-aside width="310px">
            <div style="padding: 20px">
              <el-card :body-style="{ padding: '0px'}" style="width: 270px;height: 405px">

                <el-image style="width: 270px;height: 405px" :src="cover_image" fit="cover">
                </el-image>

              </el-card>
            </div>
          </el-aside>

          <el-main>
            <div>
              <div style="float: left;">
                <div style="height: 30px;font-weight: bold">
                <span style="font-size: 24px;margin-right: 10px">

                  {{tvseriesData.tvseries_name}}
                </span>

                  <span style="font-size: 18px;margin-right: 10px">
                  {{tvseriesData.english_name}}
                </span>

                  <span style="font-size: 16px">
                  ( {{tvseriesData.years}} )
                </span>
                </div>

                <div class="info-container">
                  <span class="info-title">类型：</span>

                  <span class="info-title">{{tvseriesData.category}}</span>
                </div>

                <div class="info-container">
                  <span class="info-title">地区：</span>

                  <span class="info-title">{{tvseriesData.orgin_place}}</span>
                </div>

                <div class="info-container">
                  <div class="info-title">语言：</div>
                </div>

                <div class="info-container">
                  <div class="info-title">上映时间：</div>
                </div>

                <div class="info-container">
                  <span class="info-title">时长：</span>

                  <span class="info-title">{{tvseriesData.duration}}分钟</span>
                </div>

                <div class="info-container">
                  <div class="info-title">发行公司：</div>
                </div>

                <div class="info-container">
                  <span class="info-title">更多片名：</span>

                  <span class="info-title">{{tvseriesData.more_name}}</span>

                </div>

                <div class="info-container">
                  <span class="info-title">剧情简介：</span>

                  <span class="info-title">{{tvseriesData.intro}}</span>
                </div>

              </div>

            </div>
          </el-main>

        </el-container>

        <div style="padding: 20px" v-if="isLogin === true && tvseriesData.files !== null">
          <VideoPlayer ref="VideoPlayer" :data="{type:'tvseries',content_id:content_id,category:category,files:files,series_num:showSeriesNum}"></VideoPlayer>
        </div>

        <div style="padding: 20px" v-else-if="isLogin === true && tvseriesData.files === null">
          没有资源
        </div>

        <div style="padding: 20px" v-else>
          未登录
        </div>

      </el-aside>

      <el-main>

        <div >
          <div style="float: right">
            <el-card style="width: 160px;height: 160px">
              <div>IMDb</div>

              <span style="font-size: 80px;font-family: agency">{{tvseriesData.imdb}}</span>
              <span style="font-size: 30px;font-family: agency">/10</span>
            </el-card>

          </div>

          <div style="float: right;margin-right: 20px">
            <el-card style="width: 160px;height: 160px">
              <div>豆瓣评分</div>

              <span style="font-size: 80px;font-family: agency">{{tvseriesData.douban}}</span>
              <span style="font-size: 30px;font-family: agency">/10</span>
            </el-card>
          </div>

          <div>
            相关动漫
          </div>

        </div>
      </el-main>
    </el-container>

<!--    <div style="float:left;width: calc(100% - 355px)">-->

<!--      -->

<!--    </div>-->

  </div>
</template>

<script>
import {getTVSeriesDetail} from '../../../../request/api'
import Common from '../../../../js/Common'
import VideoPlayer from '../../widgets/VideoPlayer'

export default {
  name: 'TVSeriesInfo',
  components: {
    VideoPlayer
  },
  data () {
    return {
      isLogin: false,
      tvseriesData: '',
      cover_image: '',
      title_image: '',
      personnelData: [],
      content_id: '',
      category: '',
      files: '',
      showSeriesNum: 1
    }
  },
  methods: {
    init () {
      this.isLogin = Common.isLogin()

      var params = {'tvseries_id': this.$route.query.tvseries_id}

      getTVSeriesDetail(params).then(res => {
        console.log(res)

        if (res.code === '90') {
          this.tvseriesData = res.data
          this.cover_image = Common.getTVSeriesCover(this.tvseriesData.id)
          // this.title_image = Common.getMovieTitle(this.tvseriesData.id)

          // if (this.tvseriesData.directors !== null) {
          //   for (var x = 0; x < this.tvseriesData.directors.length; x++) {
          //     this.personnelData.push({'character': '导演', 'personnel': this.tvseriesData.directors[x]})
          //   }
          // }
          // if (this.tvseriesData.screenwriters !== null) {
          //   for (var y = 0; y < this.tvseriesData.screenwriters.length; y++) {
          //     this.personnelData.push({'character': '编剧', 'personnel': this.tvseriesData.screenwriters[y]})
          //   }
          // }
          // if (this.tvseriesData.performers !== null) {
          //   for (var z = 0; z < this.tvseriesData.performers.length; z++) {
          //     this.personnelData.push(this.tvseriesData.performers[z])
          //   }
          // }

          if (this.tvseriesData.files !== null) {
            this.content_id = this.tvseriesData.id
            this.files = this.tvseriesData.files
            this.$nextTick(() => {
              this.$refs.VideoPlayer.init()
            })
          }

          if (this.tvseriesData.category !== null) {
            this.category = this.tvseriesData.category
          }
          if (this.$route.query.series_num !== undefined) {
            this.showSeriesNum = this.$route.query.series_num
          }
        } else {
          this.$message.error(res.msg)
        }
      }).catch((error) => {
        // error

        console.log(error)
      })
    }

  },
  created () {
    this.init()
  },
  watch: {
    '$route' (to, from) {
      this.init()
    }
  }
}
</script>

<style scoped>

.info-container{
  margin: 20px 0;
}

.info-title{
  width: 160px;
  font-weight: bold
  /*background-color: #20a0ff;*/
  /*text-align: right;*/
}

.info-detail{

}

.title-image{
  width: 100%;
  height: 300px;
  background-color: #20a0ff;
}

.title-info{
  /*width:450px;*/
  height: 93px;
  padding: 20px;
  text-align: left;
}

.sc-item{
  text-align: center;
  /*float: left;*/

  margin: 20px 20px;
  /*margin: 20px auto;*/

}
.sc-list{
  flex-wrap: wrap;
  /*margin-left:@lrwith;*/
  /*margin-right:@lrwith;*/
  display: flex;
  /*justify-content: space-around;*/
  /* !主轴水平时!决定了item在交叉轴上的对齐方式，可能的值有flex-start|flex-end|center|baseline|stretch */
  /*align-items: center;*/
}
</style>



// WEBPACK FOOTER //
// src/components/pc/pages/tvseries/TVSeriesInfo.vue